import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content/all").then((r) => setContent(r.data)).catch(() => setContent({}));
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
